export const genderList = ['Male', 'Female', 'Intersex'];

// If the email regex is updated, please update in the VCB Package Components/helpers/validationHelper.js as well
// The VCB Package files need to be stand alone and should not reference this directly, but for consistency, they should remain the same
// export const emailRegex = "^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-]+(.[a-zA-Z0-9-]{2,4})?$";
export const emailRegex = '^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$';

export const dashboardButtonUrlPattern =
  /(((ftp|http|https):\/\/)|(\/)|(..\/))(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/g;
